import PropTypes from 'prop-types';
import React, {useState} from 'react';
import Spinner from '../../atoms/Spinner';

const CreditCardFooter = ({translations, genericError, onRemove}) => {
    const [isConfirmationVisible, setConfirmationVisibility] = useState(false);
    const [isRemoving, setIsRemoving] = useState(false);


    const handleRemove = async () => {
        if (!genericError) {
            setIsRemoving(true);
            await onRemove();
        }
    };

    const handleClick = () => {
        if (!genericError) {
            setConfirmationVisibility(false);
        }
    };

    return (
        <div className={`credit-card-footer ${isRemoving ? 'is-removing' : ''}`}>
            {!genericError && isRemoving && <Spinner />}
            {
                isConfirmationVisible ?
                    (
                        <>
                            <button
                                type="button"
                                className="credit-card-footer-btn remove-btn"
                                disabled={genericError}
                                onClick={handleRemove}
                            >
                                {translations.creditCard.confirmRemove}
                            </button>
                            <button
                                type="button"
                                className="credit-card-footer-btn cancel-btn"
                                disabled={genericError}
                                onClick={handleClick}
                            >
                                {translations.common.cancel}
                            </button>
                        </>
                    ) : (
                        <button
                            type="button"
                            className="credit-card-footer-btn select-btn"
                            disabled={genericError}
                            onClick={() => !genericError && setConfirmationVisibility(true)}
                        >
                            {translations.creditCard.labelRemove}
                        </button>

                    )
            }
        </div>
    );
};

CreditCardFooter.propTypes = {
    translations: PropTypes.shape({
        creditCard: PropTypes.shape({
            confirmRemove: PropTypes.string.isRequired,
            labelRemove: PropTypes.string.isRequired
        }).isRequired,
        common: PropTypes.shape({
            cancel: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    genericError: PropTypes.bool.isRequired,
    onRemove: PropTypes.func.isRequired
};

export default CreditCardFooter;
